<template>
  <div class="clients-table">
    <div class="row filters mb-4">
      <div class="col-2">
        <b-field>
          <b-datepicker
            @input="load"
            v-model="datesFilter"
            :years-range="[-100, 100]"
            :date-formatter="bDateRangeFormatter"
            placeholder="Data de Criação"
            trap-focus
            range
          >
            <button
              @click="
                datesFilter = null;
                load();
              "
              v-app-button.icon-left.clear
            >
              <b-icon size="is-small" icon="close"></b-icon>Limpar
            </button>
          </b-datepicker>
        </b-field>
      </div>
      <div class="col-2">
        <b-field>
          <app-autocomplete
            placeholder="Filtrar por Rede"
            field="name"
            :searchFunction="searchNetworkFn"
            :resourceIdFunction="resourceNetworkFn"
            v-model="filters.network_id"
            @selected="load"
          ></app-autocomplete>
        </b-field>
      </div>
      <div class="col-2">
        <b-field>
          <b-select
            @input="load"
            v-model="filters.type"
            placeholder="Filtrar por Função"
          >
            <option :value="undefined">Todas</option>
            <option v-for="type in typeOptions" :key="type[0]" :value="type[0]">
              {{ type[1] }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="col-2">
        <app-input
          @input="onInput"
          v-model="filters.term"
          placeholder="Pesquisar"
        ></app-input>
      </div>
    </div>

    <button
      class="button mb-4"
      :disabled="!checkedRows.length"
      @click="() => toggleUsers(true)"
    >
      Ativar selecionados
    </button>
    <button
      class="button ml-2 mb-4"
      :disabled="!checkedRows.length"
      @click="() => toggleUsers(false)"
    >
      Desativar selecionados
    </button>

    <button
      class="button mb-4 ml-2"
      :disabled="!checkedRows.length"
      @click="() => toggleExUsers(true)"
    >
      Desabilitar selecionados
    </button>
    <button
      class="button ml-2 mb-4"
      :disabled="!checkedRows.length"
      @click="() => toggleExUsers(false)"
    >
      Habilitar selecionados
    </button>

    <b-table
      :data="data"
      :loading="loading"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      aria-next-label="Próxima Página"
      aria-previous-label="Página Anterior"
      aria-page-label="Página"
      aria-current-label="Página Atual"
      checkable
      :checked-rows.sync="checkedRows"
    >
      <template slot-scope="props">
        <b-table-column field="active" label="Ativo">
          <b-icon
            v-if="props.row.active"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>

        <b-table-column field="has_card" label="Tem Cartão?">
          <b-icon
            v-if="props.row.has_card"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>

        <b-table-column field="is_card_active" label="Ativou Cartão?">
          <b-icon
            v-if="props.row.is_card_active"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>


        <b-table-column field="has_card" label="Tem Mapipay?">
          <b-icon
            v-if="props.row.account"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>


        <b-table-column field="points" label="Status Mapipay">
          {{ props.row.account_status | string }}
        </b-table-column>


        <b-table-column label="Incompleto?">
          <b-icon
            v-if="!props.row.incomplete"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>

        <b-table-column label="Participante?">
          <b-icon
            v-if="!props.row.ex_client"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>

        <b-table-column field="network" label="Rede">
          {{ props.row.network.name }}
        </b-table-column>

        <b-table-column field="unit_cnpj" label="Unidade">
          {{ props.row.unit_cnpj | VMask('##.###.###/####-##') }}
        </b-table-column>

        <b-table-column field="name" label="Nome">
          {{ props.row.name }}<br />
          <span class="client-type">{{ typeOptions[props.row.type][1] }}</span>
        </b-table-column>

        <b-table-column field="cpf" label="CPF">
          {{ props.row.cpf | VMask('###.###.###-##') }}
        </b-table-column>

        <b-table-column field="points" label="Pontos">
          {{ props.row.points | number }}
        </b-table-column>

        <b-table-column label="Opções">
          <button
            @click="edit(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Editar'"
          >
            <b-icon size="is-small" icon="pencil"></b-icon>
          </button>
          <button
            @click="onClickDeleteUser(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Deletar'"
          >
            <b-icon size="is-small" icon="delete" type="is-danger"></b-icon>
          </button>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nenhum registro encontrado.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import NetworkService from '@/services/network.service';
import ClientService from '@/services/client.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import BuefyMixin from '@/mixins/BuefyMixin';

import { ClientTypeLabel } from '@/enums/ClientTypeEnum';

import debounce from 'lodash/debounce';

export default {
  name: 'clients-table',
  mixins: [ToastMixin, BuefyMixin],
  data: () => {
    return {
      checkedRows: [],
      typeOptions: Array.from(ClientTypeLabel),
      datesFilter: null,
      filters: {},
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  computed: {
    requestFilters() {
      const [start_date, end_date] = this.datesFilter || [];
      return { start_date, end_date, ...this.filters };
    },
  },
  methods: {
    load() {
      this.loading = true;

      ClientService.get({
        page: this.page,
        perPage: this.perPage,
        ...this.requestFilters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Usuários.', 'error'))
        .finally(() => (this.loading = false));
    },
    onInput: debounce(function () {
      this.load();
    }, 400),
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteUser(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Usuário',
        message:
          'Tem certeza que deseja <b>excluir</b> este usuário? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Usuário',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteUser(id),
      });
    },
    deleteUser(id) {
      ClientService.delete(id)
        .then(() => {
          this.toastify('Usuário excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Usuário.',
            'error',
            4000
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    toggleUsers(enable) {
      const clientIds = this.checkedRows.map((client) => client.id);
      ClientService.toggleMultiple(clientIds, enable).then(() => this.load());
      this.checkedRows = [];
    },
    toggleExUsers(enable) {
      const clientIds = this.checkedRows.map((client) => client.id);
      ClientService.disableMultiple(clientIds, enable).then(() => this.load());
      this.checkedRows = [];
    },
    searchNetworkFn: NetworkService.search,
    resourceNetworkFn: NetworkService.getId,
  },
  mounted() {
    if (localStorage.clientsTableType)
      this.filters = {
        ...this.filters,
        type: localStorage.clientsTableType,
      };

    if (localStorage.clientsTableNetworkId)
      this.filters = {
        ...this.filters,
        network_id: localStorage.clientsTableNetworkId,
      };

    if (localStorage.clientsTableTerm)
      this.filters = {
        ...this.filters,
        term: localStorage.clientsTableTerm,
      };
    this.load();
  },
  watch: {
    'filters.type': (newValue) => {
      localStorage.clientsTableType =
        typeof newValue === 'number' ? newValue : '';
    },
    'filters.network_id': (newValue) => {
      localStorage.clientsTableNetworkId = newValue || '';
    },
    'filters.term': (newValue) => {
      localStorage.clientsTableTerm = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.client-type {
  font-style: italic;
  color: var(--color-primary);
}
</style>
